import { TagComponentTypes } from '@/models/common/tag-component-types.model';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'PageContentBlock',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    tagStatus: {
      type: String,
      default: '',
    },
    tagStatusType: {
      type: String as PropType<TagComponentTypes>,
      default: '',
    },
  },
  setup(props) {
    const headerHeight = props.subtitle ? '70px' : '48px';

    return {
      headerHeight,
    };
  },
});
